// Auto-detect browser language and switch Shopify locale once per user
(function() {
  const KEY = 'autoLocaleDone';

  function getBrowserLang() {
    try {
      const full = (navigator.languages && navigator.languages[0]) || navigator.language || '';
      return (full || '').toLowerCase();
    } catch (e) {
      return '';
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function() {
    try {
      if (window.Shopify && Shopify.designMode) return; // don't auto-switch in theme editor
      if (localStorage.getItem(KEY) === 'true') return; // already attempted once

      const current = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      const browserFull = getBrowserLang(); // e.g. 'de-de'
      if (!browserFull) return;
      const browserBase = browserFull.split('-')[0]; // e.g. 'de'

      // Find the language localization form (input name="locale_code")
      const allForms = Array.from(document.querySelectorAll('localization-form'));
      const langForm = allForms.find((el) => el.querySelector('input[name="locale_code"]'));
      if (!langForm) return;

      const form = langForm.querySelector('form');
      const input = langForm.querySelector('input[name="locale_code"]');
      const items = Array.from(langForm.querySelectorAll('a[data-value]'));
      if (!form || !input || !items.length) return;

      // Match exact locale, else match base language
      const findMatch = (code) => items.find((a) => (a.dataset.value || '').toLowerCase() === code);
      const exact = findMatch(browserFull);
      const base = findMatch(browserBase);
      const target = exact || base;
      if (!target) return;

      const targetCode = (target.dataset.value || '').toLowerCase();
      if (!targetCode) return;

      // If already on that locale, mark done and exit
      if (targetCode === current) {
        try { localStorage.setItem(KEY, 'true'); } catch(e) {}
        return;
      }

      // Submit the localization form to switch locale
      input.value = target.dataset.value; // use original case
      try { localStorage.setItem(KEY, 'true'); } catch(e) {}
      form.submit();
    } catch (e) {
      // no-op
    }
  });
})();
